// extracted by mini-css-extract-plugin
export default {"alert_danger":"CopyText_alert_danger__zku6G"};